import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/banner_livestream.png'
import _imports_1 from '@/assets/images/program/image-schedule2023.jpg'
import _imports_2 from '@/assets/images/floorMap.png'
import _imports_3 from '@/assets/images/info-event.jpg'
import _imports_4 from '@/assets/images/user-circle-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-02852faa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-link" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.twitch.tv/vr_jmof/"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "公式動画配信 / Official Livestream",
      width: "300"
    })
  ])
], -1))
const _hoisted_2 = { class: "dialog-button" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M152 64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0C141.3 0 152 10.75 152 24V64zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V192H48V448z"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M565.6 36.24C572.1 40.72 576 48.11 576 56V392C576 401.1 569.8 410.9 560.5 414.4L392.5 478.4C387.4 480.4 381.7 480.5 376.4 478.8L192.5 417.5L32.54 478.4C25.17 481.2 16.88 480.2 10.38 475.8C3.882 471.3 0 463.9 0 456V120C0 110 6.15 101.1 15.46 97.57L183.5 33.57C188.6 31.6 194.3 31.48 199.6 33.23L383.5 94.52L543.5 33.57C550.8 30.76 559.1 31.76 565.6 36.24H565.6zM48 421.2L168 375.5V90.83L48 136.5V421.2zM360 137.3L216 89.3V374.7L360 422.7V137.3zM408 421.2L528 375.5V90.83L408 136.5V421.2z"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dialog-image",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-map" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "dialog-image",
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "program-wrap" }
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "inner" }
const _hoisted_11 = { class: "info-description" }
const _hoisted_12 = { class: "info-attention" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "event-link" }
const _hoisted_16 = { class: "text-main" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_4
}, null, -1))
const _hoisted_18 = { class: "text-sub" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogBox = _resolveComponent("DialogBox")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_ProgramCard = _resolveComponent("ProgramCard")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_2')), 1),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogTimetable = true))
      }, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('button_schedule')), 1)
      ]),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogMap = true))
      }, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('button_map')), 1)
      ]),
      _withDirectives(_createVNode(_component_DialogBox, {
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogTimetable = false))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.dialogTimetable]
      ]),
      _withDirectives(_createVNode(_component_DialogBox, {
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogMap = false))
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.dialogMap]
      ])
    ]),
    _createVNode(_component_Heading, { tag: "h2" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h_1')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_ProgramCard, { data: _ctx.eventData }, null, 8, ["data"])
    ]),
    _createVNode(_component_Heading, { tag: "h2" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-h')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$props.i18n.$text('info-description')), 1),
        _createElementVNode("ul", _hoisted_12, [
          _createElementVNode("li", _hoisted_13, _toDisplayString(_ctx.$props.i18n.$text('info-attention_1')), 1),
          _createElementVNode("li", _hoisted_14, _toDisplayString(_ctx.$props.i18n.$text('info-attention_2')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_router_link, {
        class: "link",
        to: "/access/instances"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('button_access_main')), 1)
          ]),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$props.i18n.$text('button_access_sub')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}